import React from 'react';
import { Text } from '@Sage/hoi-poi-ui';

const NicknameCell = (params) => {
    const { value } = params;
    return (
        <div className="sender-nickname-cell">
            <Text bold>{value}</Text>
        </div>
    );
};

export default NicknameCell;
